import Vue from 'vue'
import VueGtag from 'vue-gtag'
Vue.use(VueGtag, {
  config: { id: 'G-53NH3H7S2L' }
})
